export default "__VITE_ASSET__DFaHU5s6__"